{
  "_license": "Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.",
  "tab": {
    "players": "Players",
    "qr": "QR Link"
  },
  "tournaments": {
    "title": "Tournaments",
    "loading": "Loading tours...",
    "menuLabel": "Tour options",
    "showFinished": "Show finished",
    "hideFinished": "Hide finished",
    "showFinishedSingleRounds": "Show finished single rounds",
    "hideFinishedSingleRounds": "Hide finished single rounds",
    "statusContinue": "Continue",
    "statusPause": "Pause",
    "statusArchive": "Archive",
    "statusSleep": "Sleep",
    "statusCancel": "Cancel",
    "statusUpdateSent": "Updating status to {status}...",
    "statusUpdateAck": "Tour status updated.",
    "statusUpdateQueued": "Waiting for websocket...",
    "archiveTitle": "Tour updated",
    "archiveMessage": "Tour status was updated.",
    "loadError": "Unable to load tours.",
    "empty": "No tours found. Create a new one.",
    "noTours": "No tours found.",
    "defaultName": "New tour",
    "namePlaceholder": "Tour name",
    "creating": "Creating tour...",
    "createCta": "New tour",
    "singleRoundCta": "Single round",
    "createdNotice": "New tour created. Select it from the list.",
    "createdWithId": "Tour created: {id}",
    "createFailed": "Unable to create tour right now. Try again.",
    "membersTitle": "Tour members",
    "membersLoading": "Loading players...",
    "membersCount": "Selected: {selected}/{max}",
    "membersLoadError": "Unable to load platform players.",
    "playerProvisioning": "Setting up your player profile...",
    "playerProvisioningRetry": "Player profile setup is delayed. Try again.",
    "playerProvisioningTimeout": "Player profile setup timed out. Retry to continue.",
    "playerProvisioningActionRetry": "Retry player setup",
    "playerProvisioningBlocked": "Wait until your player profile is ready before creating a tour.",
    "creatorMemberLocked": "Your player is always part of the tour and cannot be removed.",
    "creatorMemberRequired": "Your player profile must be included before creating a tour.",
    "shareCta": "Share",
    "shareTitle": "Share {name}",
    "shareSubtitle": "Anyone with this link can view live tour results.",
    "shareAction": "Share link",
    "shareClose": "Close",
    "shareLoadError": "Unable to create an invite link for this tour.",
    "shareSendError": "Unable to share invite link on this device.",
    "shareCopied": "Invite link copied to clipboard.",
    "openButton": "Open",
    "newRoundCta": "Add round",
    "roundsTitle": "Rounds",
    "unfinishedRoundsTitle": "Unfinished rounds",
    "hiddenToursSingleRoundsTitle": "Single rounds",
    "roundsLoading": "Loading rounds...",
    "roundsEmpty": "No rounds found.",
    "roundsLoadError": "Unable to load rounds.",
    "myToursAndRoundsSummary": "Tours: {tours} · Unfinished rounds on tours: {rounds}",
    "roundFallbackName": "Round",
    "roundOpen": "Open",
    "roundStart": "Start",
    "roundUpdate": "Update",
    "roundSettings": "Round settings",
    "roundResults": "Results",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "editCta": "Edit",
    "gamesTitle": "Games",
    "gamesCount": "{count} games",
    "gamesLoading": "Loading games...",
    "gamesEmpty": "No games selected.",
    "gamesLoadError": "Unable to load games.",
    "groupsLoading": "Loading groups...",
    "groupsLoadError": "Unable to load groups.",
    "gameFallbackName": "Game",
    "gameTypeUnknown": "Other",
    "gameTypeLabel": "Type:",
    "gameTypeMissing": "Type: Unknown",
    "gameWeightLabel": "Weight",
    "gameDetailsTitle": "Game details",
    "gameDetailsEmpty": "No description available.",
    "gameCalculationLabel": "Calculation:",
    "addGame": "Add game",
    "addGameTitle": "Add game",
    "addGameEmpty": "All games already added."
  },
  "tourEdit": {
    "playersTitle": "Players",
    "addPlayer": "Add player",
    "removePlayer": "Remove",
    "playerCreateTemporary": "Create temporary",
    "playerTemporarySelected": "Temporary selected",
    "playerSearchPlaceholder": "Search player",
    "playerCurrentUserFallback": "You",
    "playerConfirmSelectOrTemporary": "Select an existing player or mark as temporary before confirming.",
    "playerConfirmEmpty": "Enter a player name before confirming.",
    "playerAlreadyInTour": "Player is already in the tour.",
    "playerConfirmA11y": "Confirm player row",
    "playerCancelA11y": "Cancel player row",
    "playerTemporaryToggleA11y": "Toggle temporary player",
    "playerInviteTooltip": "Invite",
    "playerInviteA11y": "Invite {name}",
    "playerInviteTitle": "Invite {name}",
    "playerInviteSubtitle": "Share this link with {name} to join this tour.",
    "playerInviteLoadError": "Unable to create an invite link for this player.",
    "playerInviteShareError": "Unable to share invite link.",
    "playerInviteCopied": "Invite link copied to clipboard.",
    "title": "Tour edit",
    "breadcrumbTitle": "Tournament - edit",
    "subtitle": "Web-only editor",
    "backToTours": "Back to tours",
    "tourIdLabel": "Tour ID",
    "tourIdMissing": "Missing tour ID.",
    "webOnlyNote": "This page is available on web only.",
    "nameLabel": "Tour name",
    "namePlaceholder": "Enter tour name",
    "saveCta": "Save",
    "saving": "Saving...",
    "saveSent": "Saving tour...",
    "saveQueued": "Waiting for websocket...",
    "saveAck": "Tour updated.",
    "saveFailed": "Unable to update tour.",
    "saveAll": "Save all",
    "saveAllSent": "Saving all settings...",
    "loading": "Loading tour...",
    "loadError": "Unable to load tour.",
    "nameRequired": "Enter a tour name.",
    "addRound": "Add round",
    "roundNameLabel": "Round name",
    "roundDateLabel": "Play date",
    "roundDateUnset": "Set date",
    "roundDatePicker": "Open calendar",
    "roundDatePickerTitle": "Pick a date",
    "roundDatePickerToday": "Today",
    "roundCreate": "Create round",
    "roundCreateSaving": "Creating...",
    "roundCreateFailed": "Unable to create round.",
    "roundCreateNoPlayers": "No players found for this tournament.",
    "roundCreatePlayerLoading": "Loading players...",
    "addImage": "Add image",
    "uploadingImage": "Uploading image...",
    "imageUploadFailed": "Unable to upload image.",
    "imageUploadSuccess": "Tour image updated.",
    "roundPlayersTitle": "Round players",
    "roundPlayersLoading": "Loading round players...",
    "roundPlayersEmpty": "No players in this round yet.",
    "memberRemoving": "Removing player from tour...",
    "memberRemoveSent": "Removing player from tour...",
    "memberRemoved": "Player removed from tour.",
    "memberRemoveRejected": "Unable to remove player from tour.",
    "memberRemoveTimeout": "Timed out waiting for tour member removal.",
    "roundMemberRemoving": "Removing player from round...",
    "roundMemberRemoveSent": "Removing player from round...",
    "roundMemberRemoved": "Player removed from round.",
    "roundMemberRemoveRejected": "Unable to remove player from round.",
    "roundMemberRemoveTimeout": "Timed out waiting for round member removal.",
    "removeRound": "Remove round",
    "roundRemoving": "Removing round...",
    "roundRemoveSent": "Removing round...",
    "roundRemoved": "Round removed.",
    "roundRemoveRejected": "Unable to remove round.",
    "roundRemoveTimeout": "Timed out waiting for round removal.",
    "roundRemoveBlockedScores": "Round has recorded scores",
    "roundRemoveA11y": "Remove round",
    "roundPlayerRemoveBlockedScores": "Has recorded scores",
    "roundPlayerRemoveBlockedLastPlayer": "Last player in round",
    "roundPlayerRemoveA11y": "Remove player from round",
    "roundPlayerRemoveDisabledA11y": "Player cannot be removed from round",
    "roundAddPlayer": "Add player",
    "roundAddPlayerPlaceholder": "Select tour member",
    "roundAddPlayerNoCandidates": "No available tour members to add.",
    "roundAddPlayerStatusBlocked": "Round status does not allow adding players.",
    "tournamentGamesTitle": "Tournament games",
    "tournamentGamesEmpty": "No tournament-level games selected.",
    "tournamentAddGame": "Add tournament game",
    "tournamentRemoveGame": "Remove",
    "tournamentManagedLabel": "Tournament managed",
    "gameDetailsPanelTitle": "Game details",
    "gameDetailsEmptyState": "Select a game to view details.",
    "gameDetailsScopeLabel": "Scope:",
    "gameDetailsTypeLabel": "Type:",
    "gameScopeLibrary": "Library",
    "gameScopeTournament": "Tournament",
    "gameScopeRoundLocal": "Round-local",
    "cancelRound": "Cancel",
    "done": "Done",
    "playerSearchNoResults": "No players found."
  },
  "auth": {
    "loginTitle": "Log in",
    "loginCardTitle": "Welcome back",
    "loginCta": "Login",
    "loggingIn": "Signing in...",
    "loginSubtitle": "Sign in",
    "loginHint": "You will be redirected to login page.",
    "debugLabel": "Signed in",
    "debugNone": "None",
    "callbackLoading": "Completing sign in...",
    "callbackReady": "Waiting for Keycloak response",
    "continueWithGoogle": "Continue with Google",
    "orDivider": "or"
  },
  "register": {
    "title": "Create account",
    "cardTitle": "Create your account",
    "usernameLabel": "Username",
    "usernamePlaceholder": "yourusername",
    "displayNameLabel": "Display name",
    "displayNamePlaceholder": "Your nickname",
    "fullNameLabel": "Full name",
    "fullNamePlaceholder": "Your full name",
    "emailLabel": "Email",
    "emailPlaceholder": "name@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "At least 6 characters",
    "creating": "Creating...",
    "createCta": "Create account",
    "connectionLabel": "BFF connection: {status}",
    "connectionUp": "active",
    "connectionDown": "disconnected",
    "backToLogin": "Back to start",
    "statusQueued": "Sending request...",
    "statusSuccess": "Account created! Log in with your email and password.",
    "validationMissing": "Enter email, display name, full name, and password.",
    "validationAcceptTerms": "You must accept the service conditions to create an account.",
    "validationPasswordTooShort": "Password must be at least {{min}} characters.",
    "connectionMissing": "No connection to BFF. Try again.",
    "createTimeout": "Create request timed out. Please try again.",
    "userExists": "A user with that email already exists.",
    "createFailed": "Failed to create user.",
    "acceptTermsLabel": "I accept the service conditions.",
    "openTermsCta": "Read conditions",
    "closeTermsCta": "Close",
    "termsTitle": "Service conditions",
    "termsSummary": "Short version: be respectful, use Goffy for golf-related activity, and keep your account secure.",
    "termsRuleAccount": "You are responsible for activity on your account.",
    "termsRulePrivacy": "We store account data needed to run the service.",
    "termsRuleFairUse": "Do not abuse, attack, or disrupt the service.",
    "termsRuleNoWarranty": "The service is provided as-is without guarantees.",
    "termsUpdated": "These conditions may be updated over time."
  },
  "login": {
    "userNotFound": "Your user no longer exists. Please sign in again."
  },
  "start": {
    "title": "Welcome to Goffy",
    "subtitle": "Enter an invite code if you have one, or continue with a new or existing account.",
    "roundCodeLabel": "Invite code",
    "roundCodePlaceholder": "Enter invite code",
    "roundCodeRequired": "Enter an invite code to continue.",
    "roundCodeInvalid": "That invite code could not be found.",
    "roundCodeLookupFailed": "Failed to open that invite code. Try again.",
    "joinWithCodeCta": "Join with code",
    "signUpCta": "Sign up",
    "logInCta": "Log in",
    "emailLabel": "Email",
    "emailPlaceholder": "you@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter password",
    "orDivider": "or",
    "googleCta": "Continue with Google",
    "forgotPasswordCta": "Forgot password?",
    "credentialsRequired": "Enter your email and password.",
    "loginFailed": "Incorrect email or password."
  },
  "welcome": {
    "title": "Welcome",
    "body": "Choose how you want to start: create a single round, start a new tour, or open your existing tours and unfinished rounds.",
    "startSingleRound": "Start single round",
    "startTour": "Create tour",
    "myTours": "My tours and rounds",
    "myToursOpenSummary": "Tours: {tours}  Rounds: {singleRounds}",
    "myToursNav": "Tour & Rounds"
  },
  "friends": {
    "title": "Friends",
    "loading": "Loading friends...",
    "empty": "No friends added yet.",
    "myFriends": "My friends",
    "linked": "Linked user",
    "guest": "Guest profile",
    "addLinked": "Add linked player",
    "addGuest": "Add guest player",
    "searchPlaceholder": "Search players",
    "guestPlaceholder": "Guest name",
    "createGuestAndAdd": "Create guest and add",
    "add": "Add",
    "remove": "Remove",
    "editNickname": "Edit nickname",
    "cancel": "Cancel",
    "nicknamePlaceholder": "Nickname (optional)",
    "saveNickname": "Save nickname",
    "loadPlayersError": "Unable to load platform players.",
    "guestCreateFailed": "Unable to create guest player.",
    "actionFailed": "Unable to update friends.",
    "findPlayersPlaceholder": "Find players...",
    "allFriends": "All friends",
    "recent": "Recent",
    "eliteStatus": "Elite status",
    "myFriendsCount": "My friends {count}",
    "noMatches": "No friends match your search."
  },
  "debug": {
    "deeplinkTitle": "Deep link debug",
    "deeplinkPlatform": "Platform",
    "deeplinkLatest": "Latest URL",
    "deeplinkEmpty": "No deep link received yet.",
    "button": "Debug",
    "buttonLabel": "Debug information",
    "title": "Debug info",
    "userLabel": "User",
    "userIdLabel": "User ID",
    "playerIdLabel": "Player ID",
    "roundLabel": "Round ID",
    "roundNameLabel": "Round name",
    "tourLabel": "Tour ID",
    "tourNameLabel": "Tour name",
    "holeViewTraceLabel": "Hole view traceId",
    "holeScoreTraceLabel": "Hole score traceId",
    "traceNone": "None",
    "copyIdsLabel": "Copy debug ids",
    "copyIdLabel": "Copy {label}",
    "loading": "Loading names...",
    "unknown": "Unknown",
    "close": "Close",
    "disable": "Disable debug",
    "resetCoachMarks": "Reset coach marks",
    "resetCoachMarksRunning": "Resetting coach marks...",
    "resetCoachMarksSuccess": "Coach marks reset for this user.",
    "resetCoachMarksError": "Unable to reset coach marks.",
    "coachMarksTitle": "Coach marks",
    "coachMarksEmpty": "No coach marks loaded.",
    "coachMarkLabel": "Coach mark: {key}"
  },
  "coachMarks": {
    "tournamentsCreateTitle": "Create your first tour",
    "tournamentsCreateBody": "Add or create players then select New tour button to create a new tour and continue to round setup.",
    "profileImageActionsTitle": "Set your profile image",
    "profileImageActionsBody": "Upload an image or select an avatar to show together with your name.",
    "holeScoreTitle": "Score row tips",
    "holeScoreBody": "Tap Score to open score entry and register hazards or mystery game outcomes. You can also swipe left or right on a player row to adjust strokes.",
    "gotIt": "Got it"
  },
  "menu": {
    "profile": "Profile",
    "about": "About",
    "aboutTitle": "Service status",
    "aboutLoading": "Loading status...",
    "aboutEmpty": "No status data available.",
    "aboutError": "Error:",
    "aboutLoadError": "Unable to load status.",
    "aboutUnknownService": "Unknown service",
    "aboutUnknownImage": "Unknown image",
    "home": "Home",
    "friends": "Friends",
    "hole": "Hole",
    "selectGames": "Select game",
    "tour": "Tour",
    "golfCourses": "Golf courses",
    "configCourse": "Config course",
    "scoreAllHoles": "Score all holes (debug)",
    "scoreAllHolesRunning": "Scoring all holes…",
    "scoreAllHolesDone": "Entered {scores} scores across {holes} holes for {players} players. Events: {events}, mystery: {mystery}.",
    "scoreAllHolesError": "Could not score all holes.",
    "roundInfo": "Round information",
    "roundInfoLoading": "Loading round information…",
    "roundInfoError": "Could not load round information.",
    "roundInfoCopy": "Copy",
    "scoreAllHolesCountLabel": "How many holes to score?",
    "scoreAllHolesStart": "Score",
    "scoreAllHolesImport": "Import file…",
    "scoreAllHolesClean": "Clear existing players & scores before import",
    "scoreAllHolesImportHint": "Import file: create it with tools/game-calculator/fetch-round-scores.py export <ROUND_ID> (prod DB via ./scripts/open_ports_ssm.py). Players are matched by name, games and scores are replayed onto this round.",
    "scoreAllHolesImportError": "Unable to import round file.",
    "scoreAllHolesHole": "Hole {hole} (par {par})",
    "scoreAllHolesRow": "{name}: {strokes}",
    "scoreAllHolesMystery": "Mystery winners",
    "scoreAllHolesMysteryRow": "Hole {hole}: {name}",
    "ok": "OK",
    "roundResults": "Round",
    "scorecard": "Scorecard",
    "more": "Menu",
    "back": "<- Back",
    "logout": "Log out",
    "close": "Close",
    "anonymous": "Guest",
    "reportBug": "Report bug",
    "reportBugTitle": "Report bug",
    "reportBugHint": "Describe what happened. Include expected vs actual behavior.",
    "reportBugDescriptionPlaceholder": "What happened? What did you expect?",
    "reportBugAddImage": "Add image",
    "reportBugRemoveImage": "Remove image",
    "reportBugPasteHint": "Tip: paste an image from clipboard while this modal is open.",
    "reportBugSend": "Send report",
    "reportBugSending": "Sending...",
    "reportBugSent": "Bug report sent to Slack #bugs.",
    "reportBugSendFailed": "Unable to send bug report",
    "reportBugInvalidImage": "Only image files are supported.",
    "reportBugImageTooLarge": "Image is too large (max 8 MB).",
    "reportBugMissingContent": "Add a description or image before sending.",
    "reportBugFileUnsupported": "File upload is only supported on web."
  },
  "profile": {
    "title": "Profile",
    "loading": "Loading profile...",
    "loadFailed": "Unable to load profile.",
    "playerProvisioning": "Setting up your player profile...",
    "displayNameLabel": "Display name",
    "displayNamePlaceholder": "Your nickname",
    "fullNameLabel": "Full name",
    "fullNamePlaceholder": "Your full name",
    "nameLabel": "Name",
    "namePlaceholder": "Enter your name",
    "emailLabel": "Email",
    "emailPlaceholder": "name@example.com",
    "genderLabel": "Gender",
    "genderPlaceholder": "male, female, or other",
    "genderMale": "Male",
    "genderFemale": "Female",
    "genderNeutral": "Neutral",
    "handicapLabel": "Handicap",
    "handicapPlaceholder": "e.g. 12.4",
    "handicapDateLabel": "Handicap date",
    "handicapDatePlaceholder": "YYYY-MM-DD",
    "imageLabel": "Profile image",
    "uploadImage": "Upload image",
    "selectAvatar": "Select avatar",
    "removeAvatar": "Remove avatar",
    "avatarPickerTitle": "Choose an avatar",
    "avatarMore": "More",
    "avatarLoading": "Loading avatars...",
    "close": "Close",
    "save": "Save",
    "saving": "Saving...",
    "saveSuccess": "Profile saved.",
    "saveFailed": "Unable to save profile.",
    "handicapRequired": "Enter a handicap when a handicap date is set.",
    "handicapDateRequired": "Enter a handicap date when a handicap is set.",
    "invalidHandicap": "Enter a valid handicap value.",
    "invalidHandicapDate": "Enter a valid handicap date (YYYY-MM-DD).",
    "homeClubsLabel": "Home clubs",
    "homeClubsEmpty": "No home clubs selected.",
    "homeClubsAdd": "Add home club",
    "homeClubsPrimary": "Primary",
    "homeClubsSetPrimary": "Set primary",
    "homeClubsRemove": "Remove",
    "homeClubsPickerTitle": "Select home club",
    "homeClubsSearchPlaceholder": "Search clubs...",
    "homeClubsLoading": "Loading clubs...",
    "homeClubsNoResults": "No clubs found.",
    "homeClubsUnknownLocation": "Unknown location",
    "homeClubsRefresh": "Refresh",
    "homeClubsLoadFailed": "Unable to load clubs.",
    "uploading": "Uploading image...",
    "uploadSuccess": "Image uploaded.",
    "uploadFailed": "Unable to upload image.",
    "permissionDenied": "Photo library permission denied."
  },
  "teamDraw": {
    "title": "Team draw"
  },
  "serviceStatus": {
    "buttonLabel": "Service status",
    "alert": "!",
    "title": "Services unavailable",
    "allOk": "All services are running.",
    "warningsFound": "Warnings or errors detected in logs.",
    "host": "Host: {host}",
    "httpCode": "Return code: {code}",
    "unknownHost": "Unknown host",
    "envVar": "Env var: {envVar}",
    "unknownEnvVar": "Env var: unknown",
    "ipAddress": "Resolved IP: {ip}",
    "unknownTimestamp": "Unknown timestamp",
    "unknownService": "Unknown service",
    "unknownBody": "No log body",
    "continueMissing": "Continue (missing: {missing})",
    "close": "Close",
    "checkedAt": "Checked: {time}",
    "bffName": "backend-for-frontend-service"
  },
  "courseConfig": {
    "title": "Configure course",
    "manageSelectorLabel": "Course to manage",
    "manageCreateNew": "New course",
    "manageSelectedCourse": "Selected course",
    "manageNoCourses": "No courses to manage yet",
    "clubLabel": "Club",
    "clubPlaceholder": "Club name",
    "courseLabel": "Course",
    "coursePlaceholder": "Course name",
    "scanButton": "AI Scan scorecard",
    "cameraCapture": "Capture",
    "cameraCancel": "Cancel",
    "cameraUnavailable": "Could not open the camera. Check camera permissions and try again.",
    "scanRunning": "AI is reading the scorecard…",
    "scanThinkingHint": "Analyzing the photo — this can take up to a minute.",
    "scanSuccess": "Scorecard read — please review the values.",
    "scanFailed": "Could not read the scorecard. Enter the holes manually.",
    "scanNotConfigured": "Scorecard scanning isn't configured on the server yet.",
    "scanPermissionDenied": "Camera permission is required to scan.",
    "holeHeader": "Hole",
    "parHeader": "Par",
    "strokeIndexHeader": "Stroke Index",
    "teesTitle": "Tee setup",
    "addTeeButton": "Add tee",
    "teeLabel": "Tee {index}",
    "removeTeeButton": "Remove",
    "teeNameLabel": "Tee name",
    "teeNamePlaceholder": "Yellow",
    "teeGenderLabel": "Gender",
    "genderMale": "Male",
    "genderFemale": "Female",
    "genderUnisex": "Unisex",
    "teeColorLabel": "Tee color",
    "teeColorPlaceholder": "yellow",
    "teeParLabel": "Tee par",
    "makeOfficialLabel": "Add to official courses",
    "makeOfficialHint": "Official courses are shared with everyone. Leave unchecked to keep this course private to you.",
    "visibilityLabel": "Visibility",
    "visibility_official": "Official",
    "visibility_private": "Private",
    "visibility_pending": "Pending",
    "visibilityHint_official": "Shared with everyone.",
    "visibilityHint_private": "Visible only to you and players you share it with.",
    "visibilityHint_pending": "Submitted for approval; visible only to you until approved.",
    "courseRatingLabel": "Course rating",
    "slopeRatingLabel": "Slope rating",
    "cancelButton": "Cancel",
    "saveButton": "Save course",
    "saving": "Saving course...",
    "waitingConnection": "Waiting for websocket connection...",
    "saveSuccess": "Course saved {id}",
    "saveRejected": "Unable to save course.",
    "clubRequired": "Club name is required.",
    "courseRequired": "Course name is required.",
    "invalidPar": "Every hole must have a par value.",
    "invalidStrokeIndex": "Every hole must have a stroke index.",
    "teesRequired": "Add at least one tee.",
    "teeNameRequired": "Every tee must have a name.",
    "teeGenderRequired": "Every tee must have a gender value.",
    "invalidCourseRating": "Every tee must have a valid course rating.",
    "invalidSlopeRating": "Every tee must have a valid slope rating.",
    "invalidTeePar": "Every tee must have a valid par.",
    "fixBeforeSave": "Fix the following before saving:",
    "saveWithErrorsLabel": "Save anyway (with errors)",
    "parSumMismatch": "The sum of all hole pars ({sum}) must equal the Tee par ({teePar}).",
    "strokeIndexDuplicate": "Stroke index {value} is used by more than one hole (holes {holes}). Each stroke index may be used only once.",
    "strokeIndexRange": "Stroke index must be a number between 1 and 18 (hole {hole} has {value})."
  },
  "home": {
    "title": "Add players",
    "playerLabel": "Player {index}",
    "namePlaceholder": "Select player",
    "addPlayers": "+ Add players",
    "maxPlayers": "Max 8 players",
    "primaryCta": "Select games",
    "saving": "Saving...",
    "validationRequired": "Please enter at least one player.",
    "scpRequired": "Please enter an SCP for each player.",
    "saveError": "Unable to save players.",
    "scpPlaceholder": "SCP"
  },
  "players": {
    "title": "Players",
    "roundInitTitle": "New Round",
    "empty": "No players yet.",
    "addedAt": "Added: {date}",
    "wsError": "WebSocket connection failed.",
    "serviceError": "Players service error",
    "loadError": "Unable to load players.",
    "tourId": "Tour ID: {id}",
    "tourNameFallback": "Tour",
    "activeRoundsTitle": "Active rounds",
    "activeRoundsRefresh": "Refresh",
    "activeRoundsEmpty": "No active rounds found.",
    "roundsLoadError": "Unable to load rounds.",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "roundOpen": "Open",
    "roundContinue": "Continue",
    "roundFallbackName": "Course",
    "finishedRoundsTitle": "Finished rounds",
    "roundResults": "Results",
    "roundMenuLabel": "Round actions",
    "roundMenuPause": "Pause",
    "roundMenuFinish": "Finish",
    "roundMenuCancel": "Cancel",
    "roundNamePlaceholder": "Round name",
    "roundDescriptionTitle": "Round description",
    "roundDescriptionPlaceholder": "Add a description...",
    "roundDescriptionButton": "Edit round description",
    "playDateLabel": "Play date",
    "playDateQuick": "Quick dates",
    "playDateToday": "Today",
    "holesCountLabel": "Holes",
    "courseLabel": "Course",
    "courseSearchPlaceholder": "Search course",
    "courseSearchEmpty": "No courses found.",
    "addCourse": "Add course",
    "holesCountOptionLabel": "{count} holes",
    "holesCountOptionValue": "{count} holes",
    "teeLabel": "Tee",
    "teeNone": "None",
    "addTee": "Add tee",
    "addTeeTitle": "Add tee",
    "addTeeNameLabel": "Name",
    "addTeeNamePlaceholder": "Tee name",
    "addTeeCourseRatingLabel": "Course rating (optional)",
    "addTeeSlopeRatingLabel": "Slope rating (optional)",
    "addTeeSave": "Add tee",
    "addTeeNameRequired": "Tee name is required.",
    "addTeeNeedsCourse": "Select a course first.",
    "addTeeFailed": "Could not add tee. Please try again.",
    "addTemporary": "Add temporary player",
    "temporaryNamePlaceholder": "Temporary player name",
    "temporaryCreateAction": "Create player",
    "temporaryNameRequired": "Enter a temporary player name.",
    "temporaryCreateFailed": "Unable to create temporary player.",
    "temporaryCreatePending": "Wait for temporary players to be created before starting the round.",
    "temporaryCreatePendingCount": "Creating temporary players: {count}",
    "inviteOthers": "Invite Others",
    "joinWithCode": "Join with code",
    "showQr": "Show QR",
    "selectFromMembership": "Select players from the tour member list.",
    "membersUpdateTimeout": "No confirmation for tour membership update.",
    "membersUpdateSendFailed": "Unable to send tour membership update.",
    "roundInitiateSendFailed": "Unable to start the round.",
    "roundInitiateTimeout": "Round start timed out.",
    "roundInitiateRejected": "Round start was rejected.",
    "missingTour": "Tour is missing, cannot save players.",
    "singleRoundHiddenTourName": "Single round",
    "hiddenTourInitiateFailed": "Unable to start single round right now.",
    "recentlyPlayedTitle": "Recently played",
    "recentlyPlayedSubtitle": "Your last rounds",
    "searchAnyCourseHint": "Search any club, course or city",
    "lookingForAnother": "Looking for another course?",
    "nearbyCoursesTitle": "Nearby courses",
    "courseOfficialBadge": "Official",
    "coursePrivateBadge": "Private",
    "coursePendingBadge": "Pending"
  },
  "round": {
    "member": {
      "add": {
        "alreadyMember": "Player is already part of this round.",
        "playerNotInTour": "Player must be a member of the tour before joining this round.",
        "statusNotAllowed": "Players can only be added when round status is draft, active, or playing.",
        "roundNotFound": "Round could not be found.",
        "invalid": "Round member add request is invalid."
      },
      "remove": {
        "invalid": "Round member removal request is invalid.",
        "invalidPlayer": "Round member removal requires a valid player.",
        "roundNotFound": "Round could not be found.",
        "notMember": "Player is not part of this round.",
        "lastPlayer": "A round must keep at least one player.",
        "hasScores": "Player cannot be removed from this round after scores are recorded."
      }
    },
    "remove": {
      "invalid": "Round removal request is invalid.",
      "roundNotFound": "Round could not be found.",
      "hasScores": "Round cannot be removed after scores are recorded."
    },
    "initiate": {
      "membershipRequired": "All round players must be members of the tour."
    }
  },
  "tour": {
    "member": {
      "claim": {
        "invalid": "Tour member claim request is invalid.",
        "unauthorized": "Sign in to claim this player.",
        "tourNotFound": "Tour could not be found.",
        "sourceNotFound": "Player could not be found.",
        "sourceNotMember": "Player is not part of this tour.",
        "sourceNotUnclaimed": "Player is already claimed.",
        "targetMissing": "Create your player profile before claiming this player.",
        "targetAlreadyInTour": "Your player is already part of this tour.",
        "targetAlreadyInRound": "Your player is already in one or more rounds in this tour.",
        "mergeConflict": "Claim could not be completed because round data conflicts with your existing player."
      },
      "remove": {
        "invalid": "Tour member removal request is invalid.",
        "invalidPlayer": "Tour member removal requires a valid player.",
        "tourNotFound": "Tour could not be found.",
        "notMember": "Player is not part of this tour.",
        "creatorProtected": "The tour creator cannot be removed.",
        "lastMember": "A tour must keep at least one member.",
        "roundLastPlayer": "Player cannot be removed because one round would become empty.",
        "hasScores": "Player cannot be removed from this tour after scores are recorded."
      }
    },
    "initiate": {
      "creatorPlayerRequired": "Create your player profile before creating a tour.",
      "invalidPlayers": "One or more selected players could not be found.",
      "maxPlayersExceeded": "A tour can have at most 8 players."
    }
  },
  "roundResults": {
    "title": "Round results",
    "backToHole": "<- Round result",
    "missingRound": "Select a round to see results.",
    "goPlayers": "Go to players",
    "loadError": "Unable to load round results.",
    "empty": "No results yet.",
    "player": "Name",
    "total": "Tour",
    "gameFallback": "Game",
    "unknownPlayer": "Player",
    "roundFallback": "Round",
    "status": "Status: {status}"
  },
  "mysteryPrize": {
    "title": "Mystery prize",
    "subtitle": "Choose a hole and a subgame for each player.",
    "loading": "Loading mystery setup...",
    "loadError": "Unable to load mystery prize data.",
    "validationError": "Select a hole and subgame for every player.",
    "noPlayers": "No players found for this round.",
    "noSubgames": "No subgames available.",
    "holeLabel": "Hole",
    "subgameLabel": "Subgame",
    "selectHole": "Select hole",
    "selectSubgame": "Select subgame",
    "save": "Save mystery setup",
    "skip": "Skip mystery prize setup",
    "saving": "Saving...",
    "holePickerTitle": "Select hole",
    "subgamePickerTitle": "Select subgame",
    "holeTaken": "Taken"
  },
  "qr": {
    "title": "Scan to open the link",
    "subtitle": "Or tap below to open it directly",
    "fallbackError": "Using fallback link because backend is unavailable."
  },
  "selectGames": {
    "title": "Select games",
    "waiting": "Waiting for tour ID...",
    "tourIdLabel": "Current tour ID",
    "tourLabel": "Tour",
    "roundLabel": "Round",
    "playersLabel": "Players: {count}",
    "gamesLabel": "Games: {count}",
    "missing": "missing",
    "hint": "Keep this screen open until the tour is ready.",
    "gameListTitle": "Choose a game",
    "recommendedBadge": "Recommended",
    "gameInfo": "Info",
    "gameDescription": "Description",
    "infoIcon": "i",
    "infoVideoTitle": "Mystery game info",
    "infoVideoTitleByGame": "{name} game info",
    "gameNameFallback": "Game",
    "infoDescriptionTitle": "Description",
    "infoDescriptionEmpty": "No description available.",
    "infoDescriptionExtra": "This game is scored hole by hole and contributes to the total round result based on its weight.",
    "infoGameTypeTitle": "Game type",
    "infoGameTypeDefault": "Points-based side game",
    "infoWeightTitle": "Weight setting",
    "infoWeightValue": "Current weight: {weight}%",
    "infoWeightHelp": "Weight controls how much this game affects total merits. 100% gives full impact, lower values reduce impact.",
    "closeVideo": "Close",
    "gameLoadError": "Failed to load games",
    "gameStartError": "Failed to start game",
    "startGame": "Start game(s)",
    "startRound": "Start round",
    "updateCta": "Save and continue",
    "tournamentManagedLocked": "Tournament managed",
    "meritsLabel": "merits",
    "meritsPerTeamLabel": "merits per team",
    "meritDistributionTitle": "Merit distribution",
    "meritDistributionTotal": "{merits} merits to win",
    "meritWeightSetByTour": "Set by tour",
    "meritLadderA11y": "Merits per placement for {name}: {ladder}, weight {weight}%"
  },
  "roundStartSetup": {
    "title": "Round settings",
    "subtitleNamed": "Configure players and games for {name}",
    "subtitleFallback": "Configure players and games for this round",
    "loading": "Loading round setup...",
    "loadError": "Unable to load round setup.",
    "playersTitle": "Round players",
    "playersEmpty": "No players assigned to this round.",
    "playingHandicapLabel": "Playing hcp",
    "playingHandicapPlaceholder": "Play HCP",
    "groupsTitle": "Groups and teams",
    "groupsHint": "Drag a player card onto another card to swap, or tap one card and then another.",
    "groupsLocked": "Groups are locked after the round leaves draft status.",
    "groupsEmpty": "No group layout available.",
    "groupLabel": "Group {index}",
    "teamLabel": "Team {index}",
    "groupsUpdateSending": "Saving group swap...",
    "groupsUpdateSaved": "Groups updated.",
    "groupsUpdateQueued": "Group swap queued until websocket reconnects.",
    "groupsUpdateRejected": "Unable to update groups.",
    "groupsUpdateSendFailed": "Unable to send group swap update.",
    "groupsUpdateTimeout": "Group swap confirmation timed out.",
    "gamesTitle": "Round games",
    "gamesEmpty": "No games assigned to this round.",
    "addMoreGamesCta": "Change games",
    "removePlayerCta": "Remove",
    "removingPlayer": "Removing player...",
    "removeQueued": "Player remove queued.",
    "removeSent": "Player removed.",
    "removeRejected": "Unable to remove player from round.",
    "disableGameCta": "Disable",
    "enableGameCta": "Enable",
    "gamesUpdateQueued": "Round update queued.",
    "gamesUpdateSent": "Round games updated.",
    "updateCta": "Update",
    "openRoundCta": "Open round",
    "openRoundSending": "Opening round...",
    "openRoundQueued": "Round status update queued.",
    "openRoundConfirmed": "Round is now active.",
    "openRoundSendFailed": "Unable to send round status update.",
    "openRoundTimeout": "Round did not become active in time. Try again."
  },
  "tourLeaderboard": {
    "title": "Tour leaderboard",
    "tourName": "Tour: {name}",
    "roundCount": "Rounds: {count}",
    "overallTitle": "Overall leaderboard",
    "roundsPlayed": "{count} rounds",
    "highlightsTitle": "Highlights",
    "highlightBestRound": "Best round",
    "highlightMostWins": "Most round wins",
    "highlightLatestWinner": "Latest round winner",
    "highlightLead": "Lead margin",
    "perGameTitle": "Results per game",
    "winsCount": "{count} wins",
    "parBetterTitle": "Par or better",
    "albatrossCount": "{count} albatross",
    "eaglesCount": "{count} eagles",
    "birdiesCount": "{count} birdies",
    "parsCount": "{count} pars",
    "points": "{points} merits",
    "player": "Player",
    "total": "Merits",
    "gameFallback": "Game",
    "roundsTitle": "Rounds",
    "roundSectionsTitle": "Rounds",
    "roundSectionTitle": "Round {round}: {name}",
    "roundMembersEmpty": "No members in this round.",
    "roundRowLabel": "Round",
    "roundFallback": "Round",
    "roundEmpty": "No scores yet.",
    "empty": "No results yet.",
    "missingTour": "No tour selected.",
    "goTours": "Go to tours",
    "loadError": "Unable to load leaderboard.",
    "wsConnecting": "Connecting to live leaderboard...",
    "wsWaitingData": "Connected. Waiting for leaderboard data...",
    "wsRetrying": "Still waiting for leaderboard data (retry {count}).",
    "unknownPlayer": "Unknown player",
    "resultsHeader": "Results",
    "resultsButton": "Graph",
    "resultsTitle": "Tour results",
    "resultsTableTitle": "Results table",
    "resultsClose": "Close",
    "resultsError": "Unable to load results.",
    "resultsTableButton": "Table",
    "downloadCsv": "Download CSV",
    "csvError": "No tour results available to download.",
    "csvUnsupported": "CSV download is only available on web.",
    "roundPoints": "Round merits",
    "claimHeader": "Claim",
    "claimCta": "Claim",
    "claiming": "Claiming...",
    "claimPending": "Claim request sent.",
    "claimSuccess": "Player claimed into your profile.",
    "claimTokenMissing": "Claim succeeded, but temporary access could not be established. Please try again.",
    "claimRejected": "Unable to claim this player.",
    "claimSendError": "Could not send claim request.",
    "claimReleaseCta": "Cancel claim",
    "claimReleaseSendError": "Could not cancel claim.",
    "claimReleased": "Claim cancelled.",
    "waitingForRoundSetupTitle": "Round Setup In Progress",
    "waitingForRoundSetup": "Waiting for round setup to complete. You will be moved to hole 1 automatically.",
    "membersTitle": "Tour members",
    "membersClaimHint": "Claim temporary members here.",
    "membersReadOnlyHint": "Log in to claim temporary members.",
    "unassignedPlayersTitle": "Unassigned players",
    "unassignedPlayersHint": "Choose your player to start scoring.",
    "unassignedPlayersEmpty": "No unassigned players left.",
    "membersEmpty": "No members in this tour.",
    "memberTemporary": "Temporary member",
    "memberClaimed": "Claimed member"
  },
  "tourInvite": {
    "title": "Invite",
    "courseLabel": "Course"
  },
  "scorecard": {
    "title": "Scorecard",
    "player": "Player",
    "hole": "Hole",
    "par": "Par",
    "index": "Index",
    "strokes": "Strokes",
    "points": "Points",
    "out": "Out",
    "in": "In",
    "total": "Total",
    "totalGross": "Strokes",
    "totalStableford": "Points",
    "selectRoundTitle": "Select a round",
    "selectRoundLoading": "Loading rounds...",
    "selectRoundEmpty": "No rounds available.",
    "selectRound": "Select",
    "selectRoundError": "Unable to load rounds.",
    "selectRoundFallback": "Round",
    "missingRound": "No round selected.",
    "loadError": "Unable to load scorecard."
  },
  "hole": {
    "title": "Hole",
    "holeLabel": "Hole",
    "loading": "Loading hole...",
    "notRoundMember": "You are not a player in this round — live view is unavailable.",
    "scoreButtonLabel": "Score",
    "scorePopupTitle": "{name} - {holeLabel} {hole}",
    "scorePopupHandicapLabel": "Handicap strokes {value}",
    "scorePopupHandicapAndIndexLabel": "Handicap strokes {handicap} · Hcp-index {index}",
    "scorePopupMeta": "Hcp-index {hcpIndex} · Par {par}",
    "placeholder": "Scoring UI goes here.",
    "roundId": "Round: {id}",
    "tourId": "Tour: {id}",
    "gameFallbackName": "Game",
    "playerBreakdownTitle": "Merits for {name}",
    "playerBreakdownEmpty": "No merits available.",
    "positionShort": "Pos {position}",
    "positionShared": "shared",
    "roundPointsMissing": "-",
    "leaderboardShortTitle": "Leaderboard (Merits)",
    "roundColumn": "Round",
    "tourColumn": "Tour",
    "leaderboardRoundTitle": "⛳️ Leaderboard - round (Tour)",
    "noGamesSelected": "No games selected. Leaderboard is hidden.",
    "unknownPlayer": "Unknown player",
    "gamesTitle": "🏆 Games",
    "mysteryPrizeTitle": "Mystery prize",
    "mysteryPrizeSetup": "Mystery prize",
    "missingRound": "No round selected.",
    "goPlayers": "Go to players",
    "mysteryPrizeEntry": "{subgame} - {player}",
    "mysteryPrizeEntryWinner": "{subgame} - {player} (winner {winner})",
    "mysteryPrizeNone": "No mystery prize for this hole.",
    "noPlayers": "No players to show.",
    "puttOne": "1 putt",
    "puttTwo": "2 putts",
    "puttThree": "3 putts",
    "puttPlus": "+ putts",
    "eightPlusLabelWithValue": "8+({value})",
    "mysteryPrizeUnknownSubgame": "Unknown subgame",
    "mysteryPrizeUnknownPlayer": "Unknown player",
    "mysteryPrizeWinnerTitle": "Select winner",
    "mysteryPrizeWinnerSaveFailed": "Unable to save mystery prize winner.",
    "mysteryPrizeNextHoleTitle": "Mystery prize next hole",
    "mysteryPrizeNextHoleSubtitle": "On hole {hole}, the mystery prizes are selected as:",
    "mysteryPrizeSelectWinner": "Select winner",
    "mysteryPrizeBack": "Back",
    "backButton": "<- Back",
    "showDetails": "Show details",
    "hideDetails": "Hide details",
    "pickup": "Pickup",
    "roundStateTitle": "Round state",
    "roundStateEmpty": "No round state received.",
    "close": "Close",
    "leaderboardChangeTitle": "Leaderboard Changed",
    "leaderboardChangeSubtitle": "All scores submitted for Hole {hole}",
    "leaderboardChangeViewLeaderboard": "View Leaderboard",
    "leaderboardChangeContinue": "Continue",
    "netScoreLabel": "Net score",
    "netSummary": "Net {net}{vsPar}",
    "netSummaryEmpty": "Net –",
    "stablefordLabel": "Stableford",
    "menuTitle": "Select hole",
    "menuButton": "Hole {hole}",
    "menuPlayed": "Played",
    "menuNotPlayed": "Not played",
    "menuMyScore": "My score: {score}",
    "menuScoreMissing": "—",
    "menuCurrent": "Current hole",
    "prevHole": "Previous hole",
    "prevHoleSwipeHint": "Swipe again to move to the previous hole.",
    "nextHole": "Next hole",
    "nextHoleSwipeHint": "Swipe again to move to the next hole.",
    "finishRound": "Finish round",
    "finishRoundHint": "Tap to finish the round.",
    "finishSendFailed": "Unable to finish the round.",
    "eventSendFailed": "Unable to send hole event.",
    "event": {
      "water": "Water",
      "penalty": "Penalty",
      "bunker": "Bunker",
      "threePutt": "3 putts",
      "chipIn": "Chip in"
    },
    "parBadge": "Par {par}",
    "hcpIndexBadge": "Index {hcpIndex}",
    "playersLoadFailed": "Could not load players."
  },
  "notFound": {
    "title": "Oops!",
    "message": "This screen doesn't exist.",
    "cta": "Go to home screen!"
  },
  "modal": {
    "title": "Modal"
  },
  "edit": {
    "openCode": "Open up the code for this screen:",
    "autosave": "Change any of the text, save the file, and your app will automatically update.",
    "help": "Tap here if your app doesn't automatically update after making changes"
  },
  "language": {
    "label": "Language",
    "english": "English",
    "swedish": "Swedish",
    "danish": "Danish"
  },
  "course": {
    "label": "Use nearest golf course",
    "enableLocationHint": "(Enable location for this)",
    "refresh": "Refresh",
    "loading": "Finding courses...",
    "none": "No courses found nearby.",
    "permissionDenied": "Location permission denied.",
    "helpLabel": "Location help",
    "helpTitle": "Enable location to use nearest golf course",
    "helpDescription": "Allow location access in your browser or device settings to automatically find nearby courses.",
    "select": "Select a course",
    "error": "Could not load courses.",
    "insecure": "Using a default location (needs HTTPS for precise location)."
  },
  "appError": {
    "title": "Something went wrong",
    "message": "Please reload the page. If this keeps happening, contact support.",
    "retry": "Try Again"
  },
  "gameGroups": {
    "main": "Main games",
    "match": "Match games",
    "team": "Team games",
    "hazard": "Hazard games",
    "achievement": "Achievement games",
    "challenge": "Challenges",
    "other": "Other games"
  },
  "summary": {
    "title": "Round Summary",
    "missingInfo": "Missing round ID or user token.",
    "loadError": "Failed to load round data.",
    "overallTitle": "Overall leaderboard",
    "playerHeader": "Player",
    "scoreHeader": "Score",
    "gameHeader": "Merits",
    "pointsHeader": "Total Merits",
    "eventsCount": "{count} events",
    "gamesTitle": "Results per game",
    "gamesEmpty": "No game results yet.",
    "hazardsTitle": "Hazard games",
    "hazardsEmpty": "No hazard events recorded.",
    "hazardTotal": "Total {count}",
    "hazardWater": "Water {count}",
    "hazardBunker": "Bunker {count}",
    "hazardThreePutt": "3-putt {count}",
    "hazardPenalty": "Penalty {count}",
    "pointsValue": "{points} points",
    "meritsValue": "{merits} merits",
    "strokesValue": "{strokes} strokes",
    "mysteryTitle": "Mystery game highlights",
    "mysteryEmpty": "No mystery selections found.",
    "mysteryHolePrize": "Hole {hole} - {prize}",
    "mysterySubgame": "Subgame: {subgame}",
    "mysteryWinner": "Winner: {winner}",
    "mysteryPrizeFallback": "Mystery prize",
    "parBetterTitle": "Par or better by player",
    "parBetterEmpty": "No par-or-better scores yet.",
    "parBetterHoles": "Holes: {holes}",
    "parBetterHolesWithResult": "Holes: {holes}",
    "resultPar": "par",
    "resultBirdie": "birdie",
    "resultEagle": "eagle",
    "resultAlbatross": "albatross",
    "resultUnderPar": "under par",
    "unknownPlayer": "Unknown player",
    "unknownGame": "Unknown game",
    "unknownWinner": "Unknown winner",
    "unknownMysteryPrize": "Unknown mystery prize",
    "reopenRoundButton": "Reopen round",
    "doneButton": "OK"
  },
  "games": {
    "definitions": {
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "name": "Copenhagen",
        "info": "Three-player game: best net each hole scores 4, middle 2, worst 0.",
        "description": "Köpenhamn is a three-player game scored on net strokes hole-by-hole. The best net earns 4 points, the middle 2, and the worst 0. Tied players split the combined points evenly (tie for best 3/3/0, tie for worst 4/1/1, all tied 2/2/2). Most points after the round wins."
      },
      "stableford": {
        "name": "Stableford",
        "info": "Points game based on score versus par on each hole.",
        "description": "Players earn points per hole from net performance against par."
      },
      "stroke-play": {
        "name": "Stroke Play",
        "info": "Lowest total strokes wins.",
        "description": "Players are ranked by gross strokes across the round, with lower totals placing higher."
      },
      "skins": {
        "name": "Skins",
        "info": "Each hole is worth one skin.",
        "description": "The best score on a hole wins the skin; ties carry to the next hole."
      },
      "best-ball": {
        "name": "Best Ball",
        "info": "Team format using the best score on each hole.",
        "description": "Each team counts its best player score per hole."
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "name": "Best ball - worst ball",
        "info": "Team game comparing best and next net scores each hole.",
        "description": "Teams compare ordered net scores position-by-position each hole. Lower net in each comparison earns one point."
      },
      "bunker": {
        "name": "Bunker",
        "info": "Event game for bunker outcomes.",
        "description": "Tracks bunker-related outcomes during the round."
      },
      "water": {
        "name": "Water",
        "info": "Event game for water hazards.",
        "description": "Tracks water-hazard outcomes during the round."
      },
      "3-putts": {
        "name": "3 putts",
        "info": "Event game for three-putt outcomes.",
        "description": "Tracks holes where players need three putts."
      },
      "chip-in": {
        "name": "Chip in",
        "info": "Event game for chip-in achievements.",
        "description": "Awards one point each time a player chips in on a hole."
      },
      "closest-to-flag": {
        "name": "Closest to flag",
        "info": "Challenge game for precision on selected holes.",
        "description": "The player closest to the flag wins the challenge on the selected hole."
      },
      "longest-1-put": {
        "name": "Longest 1 put",
        "info": "Challenge game for the longest single putt.",
        "description": "The longest successful one-putt wins on the selected hole."
      },
      "longest-drive": {
        "name": "Longest drive",
        "info": "Challenge game for tee-shot distance.",
        "description": "The longest valid drive wins on the selected hole."
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "name": "Mystery prize",
        "info": "Secret side game with a selected subgame and hole.",
        "description": "Each player gets a hidden subgame for a selected hole, then a winner is chosen."
      }
    },
    "subgames": {
      "d4d2a4b1-5a9b-4f0d-9b94-1a8f8a5c2e11": {
        "name": "Closest to flag",
        "description": "Closest to the flag on the chosen hole."
      },
      "3e92a03c-5b70-4a3a-aad1-7db36de37d5e": {
        "name": "Longest drive",
        "description": "Longest drive on the chosen hole."
      },
      "7c1cfd58-9171-4b4a-9a71-6f1d8b9b5c30": {
        "name": "Longest 1 put",
        "description": "Longest single putt on the chosen hole."
      }
    }
  }
}
